import { Box, Text } from "@chakra-ui/react";
import { useTranslations } from "contexts/LocalizationContext";
import { FunnelButton } from "./FunnelButton";

export const Uploader = () => {
  const translations = useTranslations();

  return (
    <Box mb={10} display={{ base: "block", md: "none" }}>
      <Text fontSize="sm" textAlign="center" mt={2} color="greyscale.500">
        {translations("or_")}
      </Text>
      <FunnelButton type="scanner" />
      <FunnelButton type="uploader" />
    </Box>
  );
};
